import Select, {
  ActionMeta,
  OptionTypeBase,
  Props as SelectProps,
} from "react-select";

import React from "react";

// Mobile zoom prevention utilities - using the same approach as FormInput.tsx
const preventMobileZoom = () => {
  const viewport = document.querySelector('meta[name="viewport"]');
  if (viewport) {
    viewport.setAttribute(
      "content",
      "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
    );
  }
};

// Align reset behavior with Datepicker: robustly reset viewport and force repaint
const resetViewportOnMobile = () => {
  if (typeof window === "undefined") return;
  if (window.innerWidth <= 768) {
    const viewport = document.querySelector("meta[name=viewport]");
    if (viewport) {
      viewport.setAttribute(
        "content",
        "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no"
      );

      setTimeout(() => {
        viewport.setAttribute("content", "width=device-width, initial-scale=1");

        window.scrollTo(0, 0);

        (document.body.style as any).zoom = "1";
        setTimeout(() => {
          (document.body.style as any).zoom = "";
        }, 50);
      }, 300);
    }
  }
};

const isMobileDevice = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
};

interface MobileSelectProps<T extends OptionTypeBase = OptionTypeBase>
  extends SelectProps<T> {
  // Add any additional props if needed
}

const MobileSelect = <T extends OptionTypeBase = OptionTypeBase>(
  props: MobileSelectProps<T>
) => {
  const handleMenuOpen = () => {
    if (
      isMobileDevice() ||
      (typeof window !== "undefined" && window.innerWidth <= 768)
    ) {
      preventMobileZoom();
    }
    // Call original onMenuOpen if provided
    if (props.onMenuOpen) {
      props.onMenuOpen();
    }
  };

  const handleMenuClose = () => {
    if (
      isMobileDevice() ||
      (typeof window !== "undefined" && window.innerWidth <= 768)
    ) {
      resetViewportOnMobile();
    }
    // Call original onMenuClose if provided
    if (props.onMenuClose) {
      props.onMenuClose();
    }
  };

  const handleChange = (value: T | null, actionMeta: ActionMeta<T>) => {
    // Reset zoom when selection is made
    if (
      isMobileDevice() ||
      (typeof window !== "undefined" && window.innerWidth <= 768)
    ) {
      resetViewportOnMobile();
    }
    // Call original onChange if provided
    if (props.onChange) {
      props.onChange(value, actionMeta);
    }
  };

  return (
    <Select
      {...props}
      onMenuOpen={handleMenuOpen}
      onMenuClose={handleMenuClose}
      onChange={handleChange}
    />
  );
};

export default MobileSelect;
